import styled from 'styled-components';

export const ErrorWrap = styled.span`
  display: inline-block;
  color: red;
  margin-top: ${({ mt }) => mt || '5px'};
`;
